import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ModalComponent } from 'app/notify';

@Component({
  selector: 'app-autocomplete-modal',
  templateUrl: './autocomplete-modal.component.html',
  styleUrls: ['./autocomplete-modal.component.scss']
})

export class AutocompleteModalComponent extends ModalComponent<any> {

  public autocompleteItemForm: FormGroup = null;

  constructor(
    private formBuilder: FormBuilder
  ) {
    super();
  }

  public submit({ valid, value }): void {
    if (!valid) {
      return;
    }

    this.close(value);
  }

  public setOptions(options: any): void {
    this.createForm();

    if (null !== options.item) {
      this.autocompleteItemForm.patchValue(options.item);
    }
  }

  private createForm(): void {
    this.autocompleteItemForm = this.formBuilder.group({
      name: ['', Validators.required]
    });
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/autocomplete/autocomplete-modal/autocomplete-modal.component.ts